import { clowncar } from 'types';

import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { PhoneNumberAllocation } = protos;

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/internal/phonenumber',
      type: ClowncarAppConstants.PHONE_NUMBER_GET_ALL,
    },
  };
}

export function insert(phoneNumber: clowncar.PhoneNumberAllocation): ApiAction {
  const request = PhoneNumberAllocation.fromObject(phoneNumber);
  return {
    TockApi: {
      postProto: '/internal/phonenumber',
      type: ClowncarAppConstants.PHONE_NUMBER_INSERT,
      request,
    },
  };
}

export function update(phoneNumber: clowncar.IPhoneNumberAllocation): ApiAction {
  const request = PhoneNumberAllocation.fromObject(phoneNumber);
  return {
    TockApi: {
      putProto: '/internal/phonenumber',
      type: ClowncarAppConstants.PHONE_NUMBER_INSERT,
      request,
    },
  };
}

export function select(phoneNumber: clowncar.PhoneNumberAllocation): BaseTockAction {
  return {
    payload: phoneNumber,
    type: ClowncarAppConstants.PHONE_NUMBER_SELECT,
  };
}
